// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4788":"1ac5fa8f41df396d","6464":"854ed3578be29867","9412":"1f6630e39a2bc250"}[chunkId] + ".css";
};